<div [formGroup]="searchForm" *ngIf="searchForm" class="search-form">
    <p-toast></p-toast>
    <h3 class="global-title">
        Search box
    </h3>
    <div class="search-box-grid">

        <div>
            <p>
                Search by date
            </p>
        </div>
        <div>
            <p-dropdown appendTo="body" placeholder="Select Option" [options]="dateOptions" optionLabel="name"
                formControlName="dateOption" [showClear]="true"></p-dropdown>
            <span *ngIf="searchForm.value.dateOption && searchForm.get('dateOption')!.value.id==2">
                Date: <p-calendar formControlName="dateOnValue"></p-calendar>
            </span>
            <span *ngIf="searchForm.value.dateOption && searchForm.get('dateOption')!.value.id==1">
                From:
                <p-calendar formControlName="dateFromValue"></p-calendar>
                To:
                <p-calendar formControlName="dateToValue"></p-calendar>
            </span>
        </div>

        <div>
            <p>
                Search by amount
            </p>
        </div>
        <div>
            <p-dropdown appendTo="body" placeholder="Select Option" [options]="amountOptions" optionLabel="name"
                formControlName="amountOption" [showClear]="true"></p-dropdown>
            <span *ngIf="searchForm.value.amountOption && searchForm.get('amountOption')!.value.id != 4">
                <input pInputText formControlName="amountValue">
            </span>
            <span *ngIf="searchForm.value.amountOption && searchForm.get('amountOption')!.value.id == 4">
                <input pInputText formControlName="amountMinValue"> and
                <input pInputText formControlName="amountMaxValue">
            </span>
        </div>
        <div>
            <p>
                Search by text (student name, payment communication)
            </p>
        </div>
        <div>
            <input pInputText formControlName="textValue" [style]="{'width': '300px'}">
        </div>
    </div>
    <p-button label="Search" (onClick)="doCustomSearch()"></p-button>
    <p-button label="Reset" (onClick)="resetOptions()"></p-button>
</div>
<p-table #dataTable [value]="payments">
    <ng-template pTemplate="header">
        <tr>
            <th>
                <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'bookingId', 'startsWith')" placeholder="Search by Id" class="ui-column-filter"> -->
            </th>
            <th>
                Active
            </th>
            <th>
                <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'name', 'contains')" placeholder="Search by name" class="ui-column-filter"> -->
            </th>
            <th>
                Destination
            </th>
            <th>
                <p-calendar appendTo="body" (onSelect)="onStartDateSelect($event)" (onClearClick)="dataTable.filter('', 'startDate', 'equals')" [inputStyle]="{'width':'100%'}" 
                [showButtonBar]="true" styleClass="ui-column-filter" placeholder="Start Date" [readonlyInput]="true" dateFormat="dd/mm/yy"></p-calendar>
            </th>
            <th>
                <p-calendar appendTo="body" (onSelect)="onPaymentDateSelect($event)" (onClearClick)="dataTable.filter('', 'date', 'equals')" [inputStyle]="{'width':'100%'}" 
                [showButtonBar]="true" styleClass="ui-column-filter" placeholder="payment Date" [readonlyInput]="true" dateFormat="dd/mm/yy"></p-calendar>
            </th>
            <th>
                <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'comment', 'contains')" placeholder="Search by comment" class="ui-column-filter"> -->
            </th>
            <th>
                Type
            </th>
            <th>
                <!-- <input pInputText type="text" (input)="dataTable.filter($event.target.value, 'amount', 'contains')" placeholder="Search by amount" class="ui-column-filter"> -->
            </th>
            <th>
                Currency
            </th>
        </tr>
        <tr>
            <th>
                Booking ID
            </th>
            <th>
                Active
            </th>
            <th>
                Name
            </th>
            <th>
                Destination
            </th>
            <th>
                Departure
            </th>
            <th>
                Date
            </th>
            <th>
                Comment
            </th>
            <th>
                Type
            </th>
            <th>
                Amt
            </th>
            <th>
                Currency
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-payment>
        <tr>
            <td routerLink="/management/edit-booking/{{payment.bookingId}}">
                {{payment.bookingId}}
            </td>
            <td>
                {{payment.active}}
            </td>
            <td>
                {{payment.name}}
            </td>
            <td>
                {{payment.destination}}
            </td>
            <td>
                {{payment.bookingStartDate | date:'dd/MM/yyyy'}}
            </td>
            <td>
                {{payment.date | date:'dd/MM/yyyy'}}
            </td>
            <td>
                {{payment.comment}}
            </td>
            <td>
                {{payment.typeName}}
            </td>
            <td>
                {{payment.amount}}
            </td>
            <td>
                {{payment.currencyName}}
            </td>
        </tr>
    </ng-template>
</p-table>